exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ntr[data-v-431e592e]:hover {\n    background-color: transparent !important;\n}\n\n", ""]);
